import { ErrorMessage, Field } from "formik";
import { formatUnderscoreToSpace } from "../../utils/text-format";

export const FormTextAreaField = ({
  label = "textAreaField",
  labelClassName = "",
  name = "textField",
  className = "",
  placeholder = "",
  rows = 4,
  required = false,
  maxLength = null,
  showCharCount = false,
  disabled = false,
  ...props
}) => {
  return (
    <Field name={name}>
      {({ field, meta }) => {
        const hasError = meta.touched && Boolean(meta.error);
        const currentLength = field.value ? field.value.length : 0;
        const isNearLimit = maxLength && currentLength >= maxLength * 0.9;

        return (
          <div className={`flex flex-col gap-1.5 ${className} w-full`}>
            {label && (
              <div className="flex justify-between items-center">
                <label
                  htmlFor={name}
                  className={`text-xs md:text-sm font-semibold capitalize select-none transition-colors ${
                    hasError
                      ? "text-rose-600"
                      : labelClassName || "text-slate-700"
                  }`}
                >
                  {formatUnderscoreToSpace(label)}
                  {required && <span className="text-rose-500 ml-1">*</span>}
                </label>

                {/* Character Counter */}
                {showCharCount && maxLength && (
                  <span
                    className={`text-[11px] font-mono font-medium transition-colors ${
                      isNearLimit ? "text-rose-500" : "text-slate-400"
                    }`}
                  >
                    {currentLength}/{maxLength}
                  </span>
                )}
              </div>
            )}

            <textarea
              {...field}
              {...props}
              id={name}
              name={name}
              rows={rows}
              disabled={disabled}
              placeholder={
                placeholder ? formatUnderscoreToSpace(placeholder) : ""
              }
              required={required}
              maxLength={maxLength}
              className={`px-3.5 py-2.5 w-full rounded-xl text-xs md:text-sm resize-none
                text-slate-800 placeholder:text-slate-400 placeholder:text-xs md:placeholder:text-sm
                bg-white border transition-all duration-200 focus:outline-hidden
                disabled:bg-slate-50 disabled:text-slate-400 disabled:cursor-not-allowed ${
                  hasError
                    ? "border-rose-400 focus:border-rose-500 focus:ring-4 focus:ring-rose-500/10"
                    : "border-slate-200/90 hover:border-slate-300 focus:border-primary focus:ring-4 focus:ring-indigo-600/10 shadow-2xs"
                }`}
            />

            <div className="text-rose-500 text-xs px-0.5 min-h-[1.25rem] flex items-center font-medium">
              <ErrorMessage name={name} />
            </div>
          </div>
        );
      }}
    </Field>
  );
};
